import React from 'react'
import { Provider } from 'react-redux'
import { Router, Switch, Route, BrowserRouter } from 'react-router-dom'
import history from '../history'
import ReduxStore from './redux/Store'
import { PageLoadingContainer } from '../app/components'
import { AlertContainer } from '../app/components/alert-container'
import sessionRoutes from './views/SessionRoutes'

const App = () => {
    return (
        <Provider store={ReduxStore}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Router history={history}>
                    <AlertContainer />
                    <PageLoadingContainer />
                    <Switch>
                        {sessionRoutes.map((item, i) => (
                            <Route
                                key={i}
                                path={item.path}
                                component={item.component}
                            />
                        ))}
                    </Switch>
                </Router>
            </BrowserRouter>
        </Provider>
    )
}

export default App
